import React, { useState, useEffect } from "react";
import Loginimage from "../../images/loginImage.png";
import GreenPanelLogo from "../../images/greenpanel-logo.png";
import GreenLogo from "../../images/svg/Greenlogo.svg";
import MailIcon from "../../images/svg/MailIcon.svg";
import Lockicon from "../../images/svg/lockIcon.svg";
import HidePass from "../../images/svg/HidePass.svg";
import ShowPass from "../../images/svg/ShowPass.svg";
import "./login.css";
import { useNavigate } from "react-router-dom";
import { APIUtility } from "../../Api";
import { useDispatch } from "react-redux";
import { login } from "../../Redux/CommonSlice/authSlice";
import { addToast } from "../../Redux/CommonSlice/toastSlice";
import ToastContainer from "../../components/Common/ToastContainer";

const Login = ({ setLoggedIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoginButtonEnabled, setIsLoginButtonEnabled] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoginButtonEnabled(email && password && !emailError);
  }, [email, password, emailError]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    
    if (newEmail && !validateEmail(newEmail)) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  };

  const handleLogin = async () => {
    try {
      const Data = {
        username: email,
        password: password,
      };
      const response = await APIUtility.Login(Data);

      if (response.status === 200 || response.status === 201) {
        const accessData = response.data;

        accessData["camera_details"] = response?.data?.camera_details;
        accessData["user"] = { username: response?.data?.username, role: response?.data?.display_role_name, user_permissions: response?.data?.user_permissions };
        accessData["navigate"] = navigate;
        dispatch(login(accessData));

      } else if (response.status === 500) {
        dispatch(
          addToast({ message: " Internal Server Error", isError: true })
        );
      } else {
        dispatch(
          addToast({
            message:
              "Login failed. Please check your credentials and try again.",
            isError: true,
          })
        );
      }
    } catch (error) {
      console.error("Login error:", error);
      dispatch(
        addToast({
          message: error.message || "Login failed. Try again.",
          isError: true,
        })
      );
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && isLoginButtonEnabled) {
      handleLogin();
    }
  };

  const isValideInput = password !== "" && email !== "" && !emailError;

  return (
    <div className="w-[100%] h-[100vh] flex justify-center items-center relative">
      <img className="w-[100%] h-[100%]" src={Loginimage} alt="Login Background" />
      <div
        className="absolute w-[563px] h-[587.50px] p-[50px] rounded-[10px] backdrop-blur-[35px] flex-col justify-start items-center gap-[109px] inline-flex"
        style={{ backgroundColor: "rgba(255, 255, 255, 0.4)" }}
      >
        <div className="self-stretch h-[354.50px] flex-col justify-start items-center gap-[45px] flex">
          <div className="justify-start items-center gap-[29.75px] inline-flex">
            <div className="justify-start items-center mt-[1.5rem] gap-[4.96px] flex">
              <img className="w-auto h-[3.75rem]" src={GreenPanelLogo} alt="Greenpanel" />
            </div>
          </div>
          <div className="self-stretch h-[225px] flex-col justify-start items-start gap-[27px] flex">
            <div className="self-stretch flex-col justify-start items-start gap-[7px] flex">
              <label className="text-black text-m font-medium">Email</label>
              <div className="relative w-full">
                <img
                  src={MailIcon}
                  className="absolute left-[1.5%] mt-[10px] pr-1 border-r border-black w-10 h-6"
                  alt="Mail Icon"
                />
                <input
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  className={`login-inputs rounded ${emailError ? "border-red-500" : ""}`}
                  placeholder={emailError ? "Please enter a valid email address" : "example@mail.com"}
                  autoComplete="new-email"
                  onKeyDown={handleKeyDown}
                  style={emailError ? { borderColor: 'red', borderWidth: '2px' } : {}}
                />
                <span 
                  className={`absolute left-0 text-red-500 text-sm font-medium transition-opacity duration-200 ${
                    emailError ? 'opacity-100' : 'opacity-0'
                  }`}
                  style={{ bottom: '-25px' }}
                >
                  Please enter a valid email address
                </span>
              </div>
            </div>
            <div className="self-stretch flex-col justify-start items-start gap-[7px] flex">
              <label className="text-black text-m font-medium">Password</label>
              <div>
                <img
                  src={Lockicon}
                  className="absolute left-[10%] mt-[10px] pr-1 border-r border-black w-10 h-6"
                  alt="Lock Icon"
                />
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="login-inputs"
                  placeholder="Enter Password"
                  autoComplete="off"
                  onKeyDown={handleKeyDown}
                />
                <img
                  src={showPassword ? ShowPass : HidePass}
                  alt="Toggle Visibility Icon"
                  className="absolute right-16 w-6 h-6 mt-2 bottom-[40.7%] cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
            </div>
            <div>
              <button
                onClick={handleLogin}
                className={`text-white text-base font-bold self-stretch h-[47px] w-[463px] px-3.5 py-3 bg-green-500 rounded-[5px] justify-center items-center gap-2 inline-flex ${isValideInput ? "opacity-100" : "opacity-45"
                  }`}
                disabled={!isValideInput}
              >
                Login
              </button>
            </div>
          </div>
        </div>
        <div className="justify-start items-center gap-2.5 inline-flex">
          <img className="w-[25.09px] h-6" src={GreenLogo} alt="Green Logo" />
          <div className="text-black mb-[0.2rem] text-base font-semibold font-['Open Sans']">
            Powered By Greenpanel
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;
